import React, {useEffect, useState } from 'react'
import { withFormik, Form, Field } from 'formik'
import { changePassword } from '../utils/authService';
import { withTranslation } from 'react-i18next';
import PasswordStrengthMeter from './PasswordStrengthMeter'
import queryString from 'query-string'

const validate = (values, props) => {
  let errors = {};
  
  if (!values.oldPassword) {
    errors.oldPassword = props.t('enterOldPassword');
  }

  if (!values.password) {
    errors.password = props.t('passwordRequired');
  }

  if (values.password.toLowerCase() === values.password) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.toUpperCase() === values.password) {
    errors.password = props.t('passwordQualify');
  }

  if(!/\d/.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.length < 8) {
    errors.password = props.t('passwordQualify');
  }

  if (!/[_()~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.toLowerCase().includes(props.userProfile.givenName.toLowerCase())) {
    errors.password = props.t('passwordContainFirstName');
  }

  if (values.password.toLowerCase().includes(props.userProfile.familyName.toLowerCase())) {
    errors.password = props.t('passwordContainLastname');
  }

  if (values.password.toLowerCase().includes(props.userProfile.userName.toLowerCase())) {
    errors.password = props.t('passwordContainUsername');
  }

  if(values.password.indexOf(".")  >= 0 ) {
    errors.password = props.t('passwordContainPeriod');
  }

  if (!values.confirm) {
    errors.confirm = props.t('confirmPasswordErr');
  }else if (values.confirm !== values.password){
    errors.confirm = props.t('matchPassword');
  }

  return errors;
};

const PasswordNewComponent = (props) => {
  const {  
    values,
    handleChange,
    dirty,
    errors,
    t,
    touched,
    history,
    isSubmitting,
    accessToken,
    getUserProfile
  } = props

  const handleCancel = (e) => {
    e.preventDefault()
    const params = queryString.parse(props.location.search)
    const hash = props.location.hash
     
    if (params.callback) {
      window.location = params.callback + hash
    } else {
      history.push('/apps');
    }
  }

  useEffect(() => {
    document.title = 'City of Seattle | Set a new password';
    getUserProfile(accessToken);
  }, [t])

  const [capsLock, setCapsLock] = useState(false);

  const handleKeyDown = (e) => {
    const checkLock = e.getModifierState('CapsLock');
    if(checkLock) {
      setCapsLock(checkLock);
    } else {
      setCapsLock(checkLock);
    }
  }

  return(
    <div>
      <h2>Set a new password</h2>
        <Form className="App-form" onKeyDown={handleKeyDown}>
        <div className={"form-group form-group-lg " + (errors.oldPassword && touched.oldPassword ? 'has-error' : '')}>
            <label htmlFor="oldPassword" className="control-label">{t("oldPassword")} <span className="text-danger">*</span></label>
            <Field type="password" className="form-control" name="oldPassword" value={values.oldPassword} maxLength="20" onChange={handleChange}/>
            {errors.oldPassword && touched.oldPassword && <div className="text-danger exception-margin" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              {touched.oldPassword && errors.oldPassword}
            </div>}
          </div>
          <div className={"form-group form-group-lg password-form-group " + (errors.password && touched.password ? 'has-error' : '')}>
            <label htmlFor="password" className="control-label">{t("newPassword")} <span className="text-danger">*</span></label>
            <Field type="password" className="form-control password-field" name="password" value={values.password}  maxLength="20" onChange={handleChange}/>
            {capsLock && ( 
              <div className="exception-margin invalid-password" style={{marginBottom: '10px'}}>
                <span className="text-warning" role="alert">
                  <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>
                  <span className="sr-only">{t('capsLockIsOn')}</span>
                </span>
                {t('capsLockIsOn')}
              </div>
            )}
            <PasswordStrengthMeter password={values.password} />
            {errors.password && touched.password && <div className="text-danger exception-margin invalid-password" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              {touched.password && errors.password}
            </div>}
          </div>
          <p className="password-policy">{t('passwordPolicy')}</p>
          <div className={"form-group form-group-lg " + (errors.confirm && touched.confirm ? 'has-error' : '')}>
            <label htmlFor="confirm" className="control-label">{t("confirmNewPassword")} <span className="text-danger">*</span></label>
            <Field type="password" className="form-control" name="confirm" value={values.confirm}  maxLength="20" onChange={handleChange}/>
            {errors.confirm && touched.confirm && <div className="text-danger exception-margin" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              {touched.confirm && errors.confirm}
            </div>}
          </div>      
          <button type="button" className="btn btn-secondary btn-lg" onClick={handleCancel} >{props.t('cancel')}</button>
          <button type="submit" className="btn btn-primary btn-lg" disabled={!dirty || isSubmitting || Object.keys(errors).length !== 0}>{props.t('submit')}</button>
          </Form>
    </div>
    
  )
}

const PasswordNew = withFormik({
  mapPropsToValues({ oldPassword, password, confirm }) {
    return {
      oldPassword: oldPassword || '',
      password: password || '',
      confirm: confirm || ''
    }
  },
  validate: validate,
  handleSubmit(values, { props, setSubmitting }) {
    const { password, oldPassword } = values;
    const { accessToken } = props;
    changePassword(oldPassword, password, accessToken)
      .then(response => {
        const params = queryString.parse(props.location.search)
        const hash = props.location.hash
        if (params.callback) {
          window.location = params.callback + hash
        } else {
          props.showNotification({ type: 'success', title: props.t('passwordNewSuccessTitle'), message: props.t('passwordNewSuccess') });
          props.history.push('login');
        }
      })
      .catch(error => {
        let message = (error.response && error.response.data && error.response.data.detail) ? error.response.data.detail : props.t('registrationFailed');

        if (message.includes('The password does not meet the criteria of the password policy because:')) {
          let index = 0;
          let newMessage = 'The password does not meet the criteria of the password policy because: The password cannot contain ';
  
          if (message.includes('First Name of the user')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'First Name';
            index++;
          }
  
          if (message.includes('Last Name of the user')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'Last Name';
            index++;
          }
  
          if (message.includes('user name')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'username';
            index++;
          }
  
          message = newMessage + '.';
        }
  
        function GetConjuctionWord(index) {
          let ret = "";
          switch (index) {
            case 0:
              ret = 'the ';
              break;
            case 1:
              ret = ', ';
              break;
            case 2:
              ret = ' or ';
              break;
            default:
              ret = 'the ';
              break;
          }
  
          return ret;
        }
  
        setSubmitting(false);
        props.showNotification({
          type: 'failure',
          title: props.t('registrationFailedTitle'),
          message: message.replace('User Name', 'username')
        });
      }).finally(() => {
        setSubmitting(false);
      });
  }
})(PasswordNewComponent)

export default withTranslation()(PasswordNew);
